import config from "../config.json";
import { apiClient, getAccessToken, getUserEmail } from "./apiClient";

const SearchSubServiceType = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();
    let paramCount = 0;
    Object.entries(queryParams).forEach(([key, value]) => {
        if (value != null && value !== undefined) { params.append(key, value); paramCount++; }
    });
    let url = `${config.API_URL}/sub-service-types/search`;
    if (paramCount > 0) url += `?${params.toString()}`;
    const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${token}` };
    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const GetSubServiceTypeById = async (id) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${token}` };
    try {
        return await apiClient.get(`${config.API_URL}/sub-service-types/${id}`, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const CreateSubServiceType = async (req) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
    try {
        return await apiClient.post(`${config.API_URL}/sub-service-types`, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const UpdateSubServiceType = async (id, req) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
    try {
        return await apiClient.put(`${config.API_URL}/sub-service-types/${id}`, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const DeleteSubServiceType = async (id) => {
    const token = await getAccessToken();
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
    try {
        return await apiClient.patch(`${config.API_URL}/sub-service-types/${id}`, JSON.stringify({ status: 0 }), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const SubServiceTypeService = {
    SearchSubServiceType,
    GetSubServiceTypeById,
    CreateSubServiceType,
    UpdateSubServiceType,
    DeleteSubServiceType,
};

export default SubServiceTypeService;